import { createContext } from "react";
import type { CustomCoverContextValue } from "../model/types";

export const CustomCoverContext = createContext<CustomCoverContextValue | null>(
  null
);
